export const POS_GET_STUDENT_TRANSACTIONHISTORY =
  'POS_GET_STUDENT_TRANSACTIONHISTORY';
export const POS_GET_STUDENT_TRANSACTIONHISTORY_ERROR =
  'POS_GET_STUDENT_TRANSACTIONHISTORY_ERROR';
export const POS_GET_STUDENT_TRANSACTIONHISTORY_CLEAR_ERROR =
  'POS_GET_STUDENT_TRANSACTIONHISTORY_CLEAR_ERROR';
export const POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY =
  'POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY';
export const POS_GET_STUDENT_TRANSACTIONHISTORY_SET_VOID_SUCCESS =
  'POS_GET_STUDENT_TRANSACTIONHISTORY_SET_VOID_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/history/state/types.js